<script lang="ts">
import {stationStore } from "../store";   
const { stationName, showPlayer} = stationStore; 
import { getData } from "../api/getData"
import MiniPlayer from "./miniPlayer.svelte"

const el: HTMLElement  = document.getElementById("single-station-radio-player");  
let station: string = el.getAttribute("data-station");
const player: string = el.getAttribute("data-player");


if (player === 'true'){
	showPlayer.set(true)
} else {
	showPlayer.set(false)
}
import {getCurrentDate} from "../services/GetCurrentDate";



if (station) {	
	startApp(station)  
	setInterval(function () {
		startApp(station)  
	}, 60000 );
			 
}



function startApp(station) {
		getCurrentDate.currentDate()	
		if (station === 'prvi' || station === 'a1'){
			station = 'ra1'
		}	
		getData(station)
		
	}

</script>



{#if $stationName}
<MiniPlayer></MiniPlayer>
{/if} 


